import DroppedOrderBanner from './DroppedOrderBanner';

$(() => {
    new DroppedOrderBanner();
});